(function($) {

	$(document).ready(function() {

		// Quantity input plus/minus increment.
		function incrementValue(e) {
			e.preventDefault();
			var parent = $(e.target).closest('div');
			var currentVal = parseInt(parent.find('input.qty').val(), 10);

			if (!isNaN(currentVal)) {
				parent.find('input.qty').val(currentVal + 1).change();
			} else {
				parent.find('input.qty').val(0).change();
			}
		}

		// Quantity input plus/minus decrement.
		function decrementValue(e) {
			e.preventDefault();
			var parent = $(e.target).closest('div');
			var currentVal = parseInt(parent.find('input.qty').val(), 10);

			if (!isNaN(currentVal) && currentVal > 0) {
				parent.find('input.qty').val(currentVal - 1).change();
			} else {
				parent.find('input.qty').val(0).change();
			}
		}

		// Handle quantity plus/minus buttons.
		$('.quantity .button-plus').on('click', function(e) {
			incrementValue(e);
		});

		$('.quantity .button-minus').on('click', function(e) {
			decrementValue(e);
		});

		$(document.body).on('updated_cart_totals', function() {

			$('.quantity .button-plus').on('click', function(e) {
				incrementValue(e);
			});

			$('.quantity .button-minus').on('click', function(e) {
				decrementValue(e);
			});	
		});

		// Serialize single product add to cart form for ajax add to cart.
		$.fn.serializeArrayAll = function () {
			var rCRLF = /\r?\n/g;
			return this.map(function () {
			return this.elements ? $.makeArray(this.elements) : this;
			}).map(function (i, elem) {
			var val = $(this).val();
			if (val == null) {
				return val == null
				//next 2 lines of code look if it is a checkbox and set the value to blank 
				//if it is unchecked
			} else if (this.type == "checkbox" && this.checked == false) {
				return {name: this.name, value: this.checked ? this.value : ''}
				//next lines are kept from default jQuery implementation and 
				//default to all checkboxes = on
			} else {
				return $.isArray(val) ?
					$.map(val, function (val, i) {
					return {name: elem.name, value: val.replace(rCRLF, "\r\n")};
					}) :
					{name: elem.name, value: val.replace(rCRLF, "\r\n")};
			}
			}).get();
		};

		// Listen for changes to variants select, reset add to cart button.
		$( ".variations_form" ).on( "woocommerce_variation_select_change", function () {
			const addtocartbutton = $('.single_add_to_cart_button');

			if (addtocartbutton.data('defaulttext')) {
				addtocartbutton.removeClass('added');
				addtocartbutton.html(addtocartbutton.data('defaulttext'));
			}
		});

		$(document).on('click', '.single_add_to_cart_button:not(.disabled)', function (e) {

			var $thisbutton = $(this),
					$form = $thisbutton.closest('form.cart'),
					data = $form.find('input:not([name="product_id"]), select, button, textarea').serializeArrayAll() || 0;

			// Add default button text as data attribute.
			$thisbutton.attr('data-defaulttext', $thisbutton.text());

			$.each(data, function (i, item) {
				if (item.name == 'add-to-cart') {
					item.name = 'product_id';
					item.value = $form.find('input[name=variation_id]').val() || $thisbutton.val();
				}
			});

			e.preventDefault();

			$(document.body).trigger('adding_to_cart', [$thisbutton, data]);

			$.ajax({
				type: 'POST',
				url: woocommerce_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
				data: data,
				beforeSend: function (response) {
					$thisbutton.removeClass('added').addClass('loading');
				},
				complete: function (response) {
					$thisbutton.addClass('added').removeClass('loading');
				},
				success: function (response) {

					if (response.error & response.product_url) {
						window.location = response.product_url;
						return;
					}

					$thisbutton.html('Lagts i varukorgen');

					$(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
				},
			});

			return false;
		});

		// Scroll .added_to_cart button into view after adding to cart.
		$(document).on('added_to_cart', function() {
			$('.added-to-cart-scroll').scrollintoview({
				duration: 500,
				direction: "vertical",
			});
		});

		// // If product page notices/errors are present, scroll into view.
		// if ( $('body').hasClass('single-product') && $('.woocommerce-notices-wrapper').length > 0 ) {
		// 	$('.single_add_to_cart_button').scrollintoview();
		// }

		// Hide variations add to cart form if selected variation is out of stock.
		$( ".single_variation_wrap" ).on( "show_variation", function ( event, variation ) {
			if (variation.is_in_stock || variation.backorders_allowed) {
				$('.woocommerce-variation-add-to-cart').show();
			} else {
				$('.woocommerce-variation-add-to-cart').hide();
			}
		} );

		// Toggle mobile menu.
		$('.site-header__main__nav__menu').on('click', function() {
			$('.site-header__full-nav').toggleClass('site-header__full-nav--visible');
		});

		// Toggle mobile search/menu.
		$('.site-header__main__nav__search').on('click', function() {
			$('.site-header__full-nav').toggleClass('site-header__full-nav--visible');

			// Focus search input if mobile menu is visible.
			if ($('.site-header__full-nav').hasClass('site-header__full-nav--visible')) {
				$('input[name="s"]').focus();
			}
		});

		// Header highlights.
		function randomizeHeaderHighlights() {
			var parent = $('.site-header__top__highlights nav ul');
			var divs = parent.children();
			while (divs.length) {
				parent.append(divs.splice(Math.floor(Math.random() * divs.length), 1)[0]);
			}
		}

		if ($(window).width() < 660) {
			randomizeHeaderHighlights();

			setInterval(function() {
				randomizeHeaderHighlights()
			}, 5000);
		}
	});
})(jQuery);